import React from 'react';
import './libro_azul.css';
import libro_azul from '../../../../assets/img/libro_Azul.png'
import LA_txt from '../../../../assets/imgs/home_cinco/LA_txt.png'
import LA_vector from '../../../../assets/imgs/home_cinco/LA_vector.png'
import { useTranslation } from 'react-i18next'

export const Libro_azul = () => {

	const [t, i18n] = useTranslation("home");
	const liga_lang1='/'+i18n.language+"/libronegocios";

    return (
        <div class='LA_contenedor'>
            <div class="LA_contenedor_escritorio">
                <div class="LA_contenedor_img">
                    <img src={libro_azul} alt="Imagen libro" class="LA_libro_img" />
                </div>
                <div class="LA_contenedor_txt">
                    <div dangerouslySetInnerHTML={{__html:t('slider.new-book-top')}}></div>
                    <img src={LA_vector} alt="Imagen Vector" class="LA_linea" />
                    <p dangerouslySetInnerHTML={{__html:t('slider.first-book')}}></p> 
                    <a class="LA_button" href="/es/libronegocios">{(t('slider.more'))}</a>
                </div>
            </div>
            <div class='LA_contenedor_movil'>
                <div class="LA_movil_titulo">
                    <h2>{(t('slider.available'))} <br/>
                        <span>{(t('slider.new-book'))}</span></h2>
                </div>
                <div class="LA_movil_txt">
                    <p><span>{(t('slider.ideas-big'))}</span> {(t('slider.ideas')).replace("Ideas","")}<br/>
                    {(t('slider.world'))}
                    </p>
                </div>
                <div class="LA_movil_img">
                    <img src={libro_azul} alt='Imagen de libro azul'/>
                    <a 
                        class="LA_movil_img-button" 
                        href={liga_lang1}
                    >
                        {(t('slider.more'))}
                    </a>
                </div>
            </div>
        </div>
    )
}
